import Request from '@/jslib/dk-axios'

const getQiniuInfo = () => {
  return Request({
    url: 'https://website-api.idalhome.com/v1/app/Communal',
    method: 'GET',
  })
}

export const uploadQiniu = (data) => {
  return Request({
    url: 'https://upload-z0.qiniup.com/',
    headers: {
      'content-type': 'multipart/form-data',
    },
    method: 'POST',
    data,
  })
}

export default getQiniuInfo



// WEBPACK FOOTER //
// ./src/api/api.js